/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { CredentialsMetaResponse } from "../../models/credentialsMetaResponse.ts";

import type { DiscoverToolsRequest } from "../../models/discoverToolsRequest.ts";

import type { DiscoverToolsResponse } from "../../models/discoverToolsResponse.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { MCPOAuthCallbackRequest } from "../../models/mCPOAuthCallbackRequest.ts";

import type { MCPOAuthLoginRequest } from "../../models/mCPOAuthLoginRequest.ts";

import type { MCPOAuthLoginResponse } from "../../models/mCPOAuthLoginResponse.ts";

import type { MCPStoreTokenRequest } from "../../models/mCPStoreTokenRequest.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type postV2DiscoverAvailableToolsOnAnMcpServerResponse200 = {
  data: DiscoverToolsResponse;
  status: 200;
};

export type postV2DiscoverAvailableToolsOnAnMcpServerResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2DiscoverAvailableToolsOnAnMcpServerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2DiscoverAvailableToolsOnAnMcpServerResponseSuccess =
  postV2DiscoverAvailableToolsOnAnMcpServerResponse200 & {
    headers: Headers;
  };
export type postV2DiscoverAvailableToolsOnAnMcpServerResponseError = (
  | postV2DiscoverAvailableToolsOnAnMcpServerResponse401
  | postV2DiscoverAvailableToolsOnAnMcpServerResponse422
) & {
  headers: Headers;
};

export type postV2DiscoverAvailableToolsOnAnMcpServerResponse =
  | postV2DiscoverAvailableToolsOnAnMcpServerResponseSuccess
  | postV2DiscoverAvailableToolsOnAnMcpServerResponseError;

export const getPostV2DiscoverAvailableToolsOnAnMcpServerUrl = () => {
  return `/api/mcp/discover-tools`;
};

/**
 * Connect to an MCP server and return its available tools.
 *
 * If the user has a stored MCP credential for this server URL, it will be
 * used automatically unless use_saved_credentials is false.
 * @summary Discover available tools on an MCP server
 */
export const postV2DiscoverAvailableToolsOnAnMcpServer = async (
  discoverToolsRequest: DiscoverToolsRequest,
  options?: RequestInit,
): Promise<postV2DiscoverAvailableToolsOnAnMcpServerResponse> => {
  return customMutator<postV2DiscoverAvailableToolsOnAnMcpServerResponse>(
    getPostV2DiscoverAvailableToolsOnAnMcpServerUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(discoverToolsRequest),
    },
  );
};

export const getPostV2DiscoverAvailableToolsOnAnMcpServerMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>,
    TError,
    { data: DiscoverToolsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>,
  TError,
  { data: DiscoverToolsRequest },
  TContext
> => {
  const mutationKey = ["postV2DiscoverAvailableToolsOnAnMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>,
    { data: DiscoverToolsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2DiscoverAvailableToolsOnAnMcpServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2DiscoverAvailableToolsOnAnMcpServerMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>
  >;
export type PostV2DiscoverAvailableToolsOnAnMcpServerMutationBody =
  DiscoverToolsRequest;
export type PostV2DiscoverAvailableToolsOnAnMcpServerMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Discover available tools on an MCP server
 */
export const usePostV2DiscoverAvailableToolsOnAnMcpServer = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>,
      TError,
      { data: DiscoverToolsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2DiscoverAvailableToolsOnAnMcpServer>>,
  TError,
  { data: DiscoverToolsRequest },
  TContext
> => {
  return useMutation(
    getPostV2DiscoverAvailableToolsOnAnMcpServerMutationOptions(options),
    queryClient,
  );
};
export type postV2ExchangeOauthCodeForMcpTokensResponse200 = {
  data: CredentialsMetaResponse;
  status: 200;
};

export type postV2ExchangeOauthCodeForMcpTokensResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2ExchangeOauthCodeForMcpTokensResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2ExchangeOauthCodeForMcpTokensResponseSuccess =
  postV2ExchangeOauthCodeForMcpTokensResponse200 & {
    headers: Headers;
  };
export type postV2ExchangeOauthCodeForMcpTokensResponseError = (
  | postV2ExchangeOauthCodeForMcpTokensResponse401
  | postV2ExchangeOauthCodeForMcpTokensResponse422
) & {
  headers: Headers;
};

export type postV2ExchangeOauthCodeForMcpTokensResponse =
  | postV2ExchangeOauthCodeForMcpTokensResponseSuccess
  | postV2ExchangeOauthCodeForMcpTokensResponseError;

export const getPostV2ExchangeOauthCodeForMcpTokensUrl = () => {
  return `/api/mcp/oauth/callback`;
};

/**
 * Exchange the authorization code for tokens and store the credential.
 *
 * The frontend calls this after receiving the OAuth code from the popup.
 * On success, subsequent ``/discover-tools`` calls for the same server URL
 * will automatically use the stored credential.
 * @summary Exchange OAuth code for MCP tokens
 */
export const postV2ExchangeOauthCodeForMcpTokens = async (
  mCPOAuthCallbackRequest: MCPOAuthCallbackRequest,
  options?: RequestInit,
): Promise<postV2ExchangeOauthCodeForMcpTokensResponse> => {
  return customMutator<postV2ExchangeOauthCodeForMcpTokensResponse>(
    getPostV2ExchangeOauthCodeForMcpTokensUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(mCPOAuthCallbackRequest),
    },
  );
};

export const getPostV2ExchangeOauthCodeForMcpTokensMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>,
    TError,
    { data: MCPOAuthCallbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>,
  TError,
  { data: MCPOAuthCallbackRequest },
  TContext
> => {
  const mutationKey = ["postV2ExchangeOauthCodeForMcpTokens"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>,
    { data: MCPOAuthCallbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2ExchangeOauthCodeForMcpTokens(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2ExchangeOauthCodeForMcpTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>
>;
export type PostV2ExchangeOauthCodeForMcpTokensMutationBody =
  MCPOAuthCallbackRequest;
export type PostV2ExchangeOauthCodeForMcpTokensMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Exchange OAuth code for MCP tokens
 */
export const usePostV2ExchangeOauthCodeForMcpTokens = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>,
      TError,
      { data: MCPOAuthCallbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2ExchangeOauthCodeForMcpTokens>>,
  TError,
  { data: MCPOAuthCallbackRequest },
  TContext
> => {
  return useMutation(
    getPostV2ExchangeOauthCodeForMcpTokensMutationOptions(options),
    queryClient,
  );
};
export type postV2InitiateOauthLoginForAnMcpServerResponse200 = {
  data: MCPOAuthLoginResponse;
  status: 200;
};

export type postV2InitiateOauthLoginForAnMcpServerResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2InitiateOauthLoginForAnMcpServerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2InitiateOauthLoginForAnMcpServerResponseSuccess =
  postV2InitiateOauthLoginForAnMcpServerResponse200 & {
    headers: Headers;
  };
export type postV2InitiateOauthLoginForAnMcpServerResponseError = (
  | postV2InitiateOauthLoginForAnMcpServerResponse401
  | postV2InitiateOauthLoginForAnMcpServerResponse422
) & {
  headers: Headers;
};

export type postV2InitiateOauthLoginForAnMcpServerResponse =
  | postV2InitiateOauthLoginForAnMcpServerResponseSuccess
  | postV2InitiateOauthLoginForAnMcpServerResponseError;

export const getPostV2InitiateOauthLoginForAnMcpServerUrl = () => {
  return `/api/mcp/oauth/login`;
};

/**
 * Discover OAuth metadata from the MCP server and return a login URL.
 *
 * 1. Discovers the protected-resource metadata (RFC 9728)
 * 2. Fetches the authorization server metadata (RFC 8414)
 * 3. Performs Dynamic Client Registration (RFC 7591) if available
 * 4. Returns the authorization URL for the frontend to open in a popup
 * @summary Initiate OAuth login for an MCP server
 */
export const postV2InitiateOauthLoginForAnMcpServer = async (
  mCPOAuthLoginRequest: MCPOAuthLoginRequest,
  options?: RequestInit,
): Promise<postV2InitiateOauthLoginForAnMcpServerResponse> => {
  return customMutator<postV2InitiateOauthLoginForAnMcpServerResponse>(
    getPostV2InitiateOauthLoginForAnMcpServerUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(mCPOAuthLoginRequest),
    },
  );
};

export const getPostV2InitiateOauthLoginForAnMcpServerMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>,
    TError,
    { data: MCPOAuthLoginRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>,
  TError,
  { data: MCPOAuthLoginRequest },
  TContext
> => {
  const mutationKey = ["postV2InitiateOauthLoginForAnMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>,
    { data: MCPOAuthLoginRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2InitiateOauthLoginForAnMcpServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2InitiateOauthLoginForAnMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>
>;
export type PostV2InitiateOauthLoginForAnMcpServerMutationBody =
  MCPOAuthLoginRequest;
export type PostV2InitiateOauthLoginForAnMcpServerMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Initiate OAuth login for an MCP server
 */
export const usePostV2InitiateOauthLoginForAnMcpServer = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>,
      TError,
      { data: MCPOAuthLoginRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2InitiateOauthLoginForAnMcpServer>>,
  TError,
  { data: MCPOAuthLoginRequest },
  TContext
> => {
  return useMutation(
    getPostV2InitiateOauthLoginForAnMcpServerMutationOptions(options),
    queryClient,
  );
};
export type postV2StoreABearerTokenForAnMcpServerResponse200 = {
  data: CredentialsMetaResponse;
  status: 200;
};

export type postV2StoreABearerTokenForAnMcpServerResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2StoreABearerTokenForAnMcpServerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2StoreABearerTokenForAnMcpServerResponseSuccess =
  postV2StoreABearerTokenForAnMcpServerResponse200 & {
    headers: Headers;
  };
export type postV2StoreABearerTokenForAnMcpServerResponseError = (
  | postV2StoreABearerTokenForAnMcpServerResponse401
  | postV2StoreABearerTokenForAnMcpServerResponse422
) & {
  headers: Headers;
};

export type postV2StoreABearerTokenForAnMcpServerResponse =
  | postV2StoreABearerTokenForAnMcpServerResponseSuccess
  | postV2StoreABearerTokenForAnMcpServerResponseError;

export const getPostV2StoreABearerTokenForAnMcpServerUrl = () => {
  return `/api/mcp/token`;
};

/**
 * Store a manually entered MCP credential. Accepts a bare token (sent as Bearer, unchanged from before), an explicit `Basic <value>` or `Bearer <value>`, or a complete `Authorization:` header.
 * @summary Store a bearer token for an MCP server
 */
export const postV2StoreABearerTokenForAnMcpServer = async (
  mCPStoreTokenRequest: MCPStoreTokenRequest,
  options?: RequestInit,
): Promise<postV2StoreABearerTokenForAnMcpServerResponse> => {
  return customMutator<postV2StoreABearerTokenForAnMcpServerResponse>(
    getPostV2StoreABearerTokenForAnMcpServerUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(mCPStoreTokenRequest),
    },
  );
};

export const getPostV2StoreABearerTokenForAnMcpServerMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>,
    TError,
    { data: MCPStoreTokenRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>,
  TError,
  { data: MCPStoreTokenRequest },
  TContext
> => {
  const mutationKey = ["postV2StoreABearerTokenForAnMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>,
    { data: MCPStoreTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2StoreABearerTokenForAnMcpServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2StoreABearerTokenForAnMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>
>;
export type PostV2StoreABearerTokenForAnMcpServerMutationBody =
  MCPStoreTokenRequest;
export type PostV2StoreABearerTokenForAnMcpServerMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Store a bearer token for an MCP server
 */
export const usePostV2StoreABearerTokenForAnMcpServer = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>,
      TError,
      { data: MCPStoreTokenRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2StoreABearerTokenForAnMcpServer>>,
  TError,
  { data: MCPStoreTokenRequest },
  TContext
> => {
  return useMutation(
    getPostV2StoreABearerTokenForAnMcpServerMutationOptions(options),
    queryClient,
  );
};
